import { endpoints } from './api/endpoints';

export function getInitials(name: string): string {
  if (!name) {
    return 'RU'; // Return "RU" if no name is provided
  }

  const names = name.split(' ');
  if (names.length === 1) {
    return names[0].charAt(0).toUpperCase() + 'U'; // Return the first letter if only one name is provided
  }

  // If two names are provided, concatenate the initials of both names
  return names[0].charAt(0).toUpperCase() + names[1].charAt(0).toUpperCase();
}

export function formatDateToDDMMYYYY(isoDateString: string): string {
  const date = new Date(isoDateString); // Parse the ISO 8601 date string

  const day = date.getUTCDate().toString().padStart(2, '0'); // Get UTC day and pad with leading zero if needed
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0'); // Get UTC month (0-indexed, so add 1) and pad with leading zero if needed
  const year = date.getUTCFullYear(); // Get UTC full year

  return `${day}/${month}/${year}`;
}

const isoDateString = '2024-04-18T08:45:01.079Z';
const formattedDate = formatDateToDDMMYYYY(isoDateString);

export function calculatePercentage(score: number): number {
  let percentage: number;

  if (score < 1) {
    percentage = Math.min(Math.round(score * 100), 100);
  } else {
    percentage = Math.min(Math.round(score), 100);
  }

  return percentage;
}

export const downloadExportCSV = selectedResumeIds => {
  // Create the base URL for the export endpoint.
  const baseUrl = endpoints.exportCSV.url;

  // Map each ID into a separate 'id[]' query parameter and join them.
  const idsQuery = selectedResumeIds.map(id => `resumeIds[]=${id}`).join('&');

  // Construct the full URL with the IDs.
  const link = `${baseUrl}?${idsQuery}`;

  // Open the generated URL in a new tab.
  window.open(link, '_blank');
};
